import at from "lodash/at";
import { useField } from "formik";
import {
  FormControl,
  MenuItem,
  TextField,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { useTranslation } from "react-i18next";
import { Option } from "../../../types/option";

export default function SelectField(props: any) {
  const { label, data, infoMsg, ...rest } = props;
  //TODO dont use ANY test what props has in it, and change it!!
  const [field, meta] = useField(props);
  const { value: selectedValue } = field;
  const [touched, error] = at(meta, "touched", "error");
  const isError = touched && error && true;
  const { t } = useTranslation();

  return (
    <FormControl {...rest} error={isError}>
      <TextField
        select
        fullWidth
        label={t(label)}
        {...field}
        {...rest}
        error={isError}
        helperText={isError ? t(error) : ""}
        value={selectedValue}
        sx={{
          "& .MuiSelect-icon": { right: "40px !important" },
        }}
        InputProps={{
          endAdornment: (
            <>
              {props.infoMsg && (
                <InputAdornment position="end">
                  <Tooltip title={props.infoMsg}>
                    <HelpIcon style={{ cursor: "default" }} />
                  </Tooltip>
                </InputAdornment>
              )}
            </>
          ),
        }}
      >
        {data.map((item: Option, index: number) => (
          <MenuItem key={index} value={item.value} disabled={item.disabled}>
            {t(item.label)}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
}
